













































import Vue from 'vue'
import Modal from '@/components/Modal'
import UserProfileForm from '@/components/UserProfileForm'
import { UserProfile } from '@/types/users'
import { KeyDict } from '@/types'
import { TranscodingRegion } from '@/types/admin'
import { isMobile } from 'mobile-device-detect'
import './UserProfileContainer.scss'

export default Vue.extend({
  name: 'UserProfileContainer',
  computed: {
    isMobile (): boolean {
      return isMobile
    },
    inCast (): boolean {
      return this.$store.direct.state.events.inCast
    },
    showProfile (): boolean {
      return this.$store.direct.state.user.showProfile
    },
    profile (): UserProfile | null {
      return this.$store.direct.state.user.profile
    },
    transcodingregions (): KeyDict<TranscodingRegion> {
      return this.$store.direct.state.admin.transcodingregions
    }
  },
  data: () => ({
    editProfile: null as UserProfile | null,
    formvalid: true
  }),
  created () {
    this.editProfile = JSON.parse(JSON.stringify(this.profile))
    if (this.editProfile && !this.editProfile.encoderSettings) {
      this.editProfile.encoderSettings = {}
    }
  },
  watch: {
    profile (newVal: UserProfile | null) {
      this.editProfile = JSON.parse(JSON.stringify(newVal))
      if (this.editProfile && !this.editProfile.encoderSettings) {
        this.editProfile.encoderSettings = {}
      }
    }
  },
  methods: {
    async updateProfile () {
      try {
        if (this.editProfile !== null) {
          await this.$store.direct.dispatch.user.updateProfile(this.editProfile)
          this.$message({ type: 'success', message: 'Your profile has been updated' })
        }
      } catch(error) {
        this.$message({ type: 'error', message: 'Could not update profile' })
      }
      await this.toggleProfile(false)
    },
    async toggleProfile (payload: boolean): Promise<void> {
      this.$store.direct.dispatch.user.toggleProfileModal(payload)
    },
    updateFormValid (formvalid) {
      this.formvalid = formvalid
    }
  },
  components: {
    Modal,
    UserProfileForm
  }
})
